import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import actionDropdown from '../../../assets/actionDropdown.png';
import createReturn5 from '../../../assets/CreateReturn5.png';
import createReturnOrderNavigation from '../../../assets/createReturnOrderNavigation.png';
import createReturnOrderScreen from '../../../assets/createReturnOrderScreen.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const CreateReturnOrderHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('createReturnOrderHelp');

    return (
        <>
            <HelpTitle>{t('createReturnOrderHelp_Title')}</HelpTitle>
            <HelpBody>{t('createReturnOrderHelp_purpose')}</HelpBody>
            <HelpStep step={1}>
                <Trans
                    i18nKey={'createReturnOrderHelp_navigateToCreateReturnOrder'}
                    ns={'createReturnOrderHelp'}
                    components={{ url: <Link href={'https://reseller.amazon.com'}>{''}</Link> }}
                />
            </HelpStep>
            <HelpImage src={createReturnOrderNavigation} />
            <HelpStep step={2}>{t('createReturnOrderHelp_enterReferenceId')}</HelpStep>
            <HelpImage src={createReturnOrderScreen} />
            <HelpStep step={3}>{t('createReturnOrderHelp_locationContactData')}</HelpStep>
            <HelpStep step={4}>{t('createReturnOrderHelp_inputItemData')}</HelpStep>
            <HelpStep step={5}>{t('createReturnOrderHelp_actions')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('createReturnOrderHelp_setEligible')}</HelpBullet>
                <HelpBullet>{t('createReturnOrderHelp_override')}</HelpBullet>
                <HelpBullet>{t('createReturnOrderHelp_requestManualReview')}</HelpBullet>
                <HelpBullet>{t('createReturnOrderHelp_noCredit')}</HelpBullet>
            </HelpIndent>
            <HelpImage size={'small'} src={actionDropdown} />
            <HelpStep step={6}>{t('createReturnOrderHelp_reviewReturnRequest')}</HelpStep>
            <HelpImage size={'large'} src={createReturn5} />
        </>
    );
};

export { CreateReturnOrderHelp };
